import { render, staticRenderFns } from "./Hue.vue?vue&type=template&id=a9ab671e&"
import script from "./Hue.vue?vue&type=script&lang=js&"
export * from "./Hue.vue?vue&type=script&lang=js&"
import style0 from "./Hue.vue?vue&type=style&index=0&id=a9ab671e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports